// ArrayStorageWrapper

// Provides a subset of the Array API against a single key
// wraps localStorage or an object based on support
function ArrayStorageWrapper(key) {
  this.key = key;
  this.storage = window.LocalStorageWrapper;
  this.init();
}

ArrayStorageWrapper.prototype = {
  // init array in storage
  // if not present or is broken JSON
  init: function() {
    var set, setStr;
    setStr = this.storage.getItem(this.key);
    try {
      set = JSON.parse(setStr);
    }
    catch(e) {
      set = undefined;
    }
    if(!_.isArray(set)) {
      this.storage.setItem(this.key, JSON.stringify([]));
      this.length = 0;
    }
  },

  _get: function() {
    var str = this.storage.getItem(this.key);
    var set = JSON.parse(str);
    this.length = set.length;
    return set;
  },

  _set: function(set) {
    this.length = set.length;
    var str = JSON.stringify(set);
    return this.storage.setItem(this.key, str);
  },

  push: function(item) {
    var set = this._get();
    set.push(item);
    this._set(set);
  },

  shift: function() {
    var set = this._get();
    var item = set.shift(item);
    this._set(set);
    return item;
  },

  concat: function(arr) {
    var set = this._get();
    if(arr instanceof ArrayStorageWrapper) {
      arr = arr.toArray();
    }
    set = set.concat(arr);
    this._set(set);
  },

  splice: function(i, n) {
    var set = this._get();
    var spliced = set.splice(i, n);
    this._set(set);
    return spliced;
  },

  clear: function() {
    this._set([]);
  },

  slice: function(i, n) {
    var set = this._get();
    var sliced = set.slice(i, n);
    return sliced;
  },

  toArray: function() {
    return this._get();
  }

};

_.extend(EF.Models, {
  ArrayStorageWrapper: ArrayStorageWrapper
});